export default (that) => [
  {
    field: 'seq',
    width: 50,
    align: 'center',
    type: 'seq',
    fixed: 'left',
  },
  {
    title: that.$l('table_label_displayImage') || '图片',
    field: 'displayImage',
    width: 120,
    align: 'center',
    fixed: 'left',
    slots: { default: 'displayImage' },
  },
  {
    title: that.$l('table_label_orderGoodsNo') || '订单产品编号',
    field: 'orderGoodsNo',
    minWidth: 200,
    align: 'center',
    showHeaderOverflow: true,
  },
  {
    title: that.$l('table_label_orderGoodsDisplayName') || '产品名称',
    field: 'orderGoodsDisplayName',
    minWidth: 220,
    headerAlign: 'center',
    align: 'left',
    showHeaderOverflow: true,
  },
  {
    title: that.$l('table_label_orderNo') || '订单编号',
    field: 'orderNo',
    minWidth: 200,
    align: 'center',
    showHeaderOverflow: true,
  },
  {
    title: that.$l('table_label_custOrderNo') || '客户订单编号',
    field: 'custOrderNo',
    minWidth: 220,
    headerAlign: 'center',
    align: 'left',
    showHeaderOverflow: true,
  },
  {
    title: that.$l('table_label_retailerPo') || '零售商PO',
    field: 'retailerPo',
    minWidth: 200,
    headerAlign: 'center',
    align: 'left',
    showHeaderOverflow: true,
  },
  {
    title: that.$l('table_label_importerPo') || '代理商PO',
    field: 'importerPo',
    minWidth: 200,
    headerAlign: 'center',
    align: 'left',
    showHeaderOverflow: true,
  },
  {
    title: that.$l('table_label_salesPersonName') || '业务员',
    field: 'salesPersonName',
    minWidth: 150,
    align: 'center',
    showHeaderOverflow: true,
  },
  {
    title: that.$l('table_label_bizPersonName') || '跟单',
    field: 'bizPersonName',
    minWidth: 150,
    align: 'center',
    showHeaderOverflow: true,
  },
  {
    title: that.$l('table_label_brandName') || '品牌',
    field: 'brandName',
    minWidth: 150,
    align: 'center',
    showHeaderOverflow: true,
  },
  {
    title: that.$l('table_label_masterCategoryName') || '品类',
    field: 'masterCategoryName',
    minWidth: 150,
    align: 'center',
    showHeaderOverflow: true,
  },
  {
    title: that.$l('table_label_issueDate') || '下单日期',
    field: 'issueDate',
    minWidth: 120,
    align: 'center',
    showHeaderOverflow: true,
  },
  {
    title: that.$l('table_label_deliveryDay') || '交货日期',
    field: 'deliveryDay',
    minWidth: 120,
    align: 'center',
    showHeaderOverflow: true,
  },
  {
    title: that.$l('table_label_orderSalesAmount') || '订单金额',
    field: 'orderSalesAmount',
    minWidth: 160,
    align: 'center',
    showHeaderOverflow: true,
    formatter: ({ row }) => {
      const { salePriceAmount, salesCurrencyUnitText } = row
      return `${that.format(salePriceAmount) || '0'} ${salesCurrencyUnitText}`
    },
  },
  {
    title: that.$l('table_label_rptSalesUsd') || '统计金额',
    field: 'rptSalesUsd',
    minWidth: 160,
    align: 'center',
    showHeaderOverflow: true,
    formatter: ({ row }) => {
      const { rptSalesUsd } = row
      return `${that.format(rptSalesUsd) || '0'} ${that.$l('table_label_rptSalesUsdCurrency') || '美元'}`
    },
  },
  {
    title: that.$l('table_label_scmName') || '执行工厂',
    field: 'scmName',
    minWidth: 220,
    headerAlign: 'center',
    align: 'left',
    showHeaderOverflow: true,
  },
  {
    title: that.$l('table_label_orderScmName') || '验货工厂',
    field: 'orderScmName',
    minWidth: 220,
    headerAlign: 'center',
    align: 'left',
    showHeaderOverflow: true,
  },
  {
    title: that.$l('table_label_settlementFactoryName') || '结算工厂',
    field: 'settlementFactoryName',
    minWidth: 220,
    headerAlign: 'center',
    align: 'left',
    showHeaderOverflow: true,
  },
]
